import { _APP_CONFIG } from "../../core/config/AppConfig";
import { ArrayV2 } from "../../util/ArrayV2";
import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";
import { MEscuela } from "../model/MEscuela";
import { DataUtil } from "../util/Util";

export const _DICC_TUTOR_ASIGNACIONES: Map<number, Entidad.ITutorAsignacion> = new Map();

/** Diccionario extra (IMPORTANTE: USO SOLO DE MAINPAGE (por ahora)):
 * * Map<idTutor, asignaciones<Map<idAsignacion, dataITutorAsignacion>>> */
export const _DICC_ASIGNACIONES_POR_TUTOR: Map<number, Map<number, Entidad.ITutorAsignacion>> = new Map();

/** Diccionario extra (IMPORTANTE: USO SOLO DE MAINPAGE (por ahora)):
 * * Map<idAlumno, asignaciones<Map<idAsignacion, dataITutorAsignacion>>> */
export var _DICC_ASIGNACIONES_POR_ALUMNO: Map<number, Map<number, Entidad.ITutorAsignacion>> = new Map();

const IDREQUEST = Entidad.CTipoRequest.TutorAsignacion;

export function _SvPadreObtenerAsignacionesAlumno(escuelas: MEscuela[]) {
    const url = _APP_CONFIG.URL_RSTV2 + "padre/ObtenerAsignacionesAlumno";
    return new ArrayV2<MEscuela>()
        ._Push(...escuelas)
        ._MapAwait(async ({ IdKinder }) => {
            const currentDateStr = await DataUtil._GetMaxDate(IDREQUEST, IdKinder);
            const params = {
                "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
                "IdEscuela": IdKinder,
                "Modificacion": currentDateStr,
            }
            return DataDRequest._Request4List(url, "GET", params, IDREQUEST, IdKinder);
        });
}

interface IAsignarTutorResponse {
    Resultado: number,
    /** { IdTutor: StrPassword } */
    tutor: { [key: number]: string },
}
export function _SvAlumnoAsignarTutor(idAlumno: number, idTutor: number, idEscuela: number, esMonitoreo: boolean): Promise<DataDRequest.IRequestResponseA & IAsignarTutorResponse> {
    const url = _APP_CONFIG.URL_RSTV2 + "alumno/AsignarTutor";
    const params = {
        "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdAlumno": idAlumno,
        "IdTutor": idTutor,
        "IdEscuela": idEscuela,
        "Monitoreo": esMonitoreo
    }
    return DataDRequest._Request5(url, "POST", params, Entidad.CTipoRequest.TutorAsignacion);
}

export function _SvAlumnoEliminarTutorAsignacion(idAsignacion: number): Promise<DataDRequest.IResultadoPeticion<undefined>> {
    const url = _APP_CONFIG.URL_RSTV2 + "alumno/EliminarTutorAsignacion";
    const params = {
        "IdAsignacion": idAsignacion
    }

    return new Promise(function (resolve, reject) {
        DataDRequest._Request(url, "POST", params, (result: DataDRequest.IRequestResponseBase) => {
            resolve({
                Resultado: result?.Resultado || -100,
                TipoRequest: Entidad.CTipoRequest.TutorAsignacion
            })
        });
    });
}
